import serviceFoto1 from '../../assets/images/service1.png'
import serviceFoto2 from '../../assets/images/service2.png'
import serviceFoto3 from '../../assets/images/service3.png'

export const serviceData = [
    {
        title: 'Certificación',
        text: 'Calibramos equipos con valores de magnitudes que han sido aceptados por organismos nacionales o internacionales. Entregamos un Certificado de Calibración, donde se evidencia el proceso de verificación, ajuste y calibración para garantizar que el instrumento está en óptimas condiciones técnicas y metrológicas.',
        image: serviceFoto2,
    },
    {
        title: 'Calidad',
        text: 'Profesionalismo, conocimiento y experiencia aplicada a la calidad a un costo mínimo. Somos un equipo altamente calificado que puede resolver tus problemas manteniendo el presupuesto ajustado a las necesidades del cliente. ',
        image: serviceFoto3,
    },
    {
        title: 'Respuesta',
        text: 'Disponemos de herramientas e instrumentación de alta tecnología para la verificación en sitio: además contamos con un adecuado laboratorio de mantenimiento en nuestras instalaciones para intervenir equipos que requieran mayor complejidad de diagnóstico y reparación.',
        image: serviceFoto1,
    },

]